import { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { NotificationManager } from 'react-notifications';
import { useDispatch, useSelector } from 'react-redux';

import FormInput from '../../components/formInput/formInput';
import axiosInstance from '../../config/axios';
import { loader } from '../../store/actions/loader';
import InlineLoading from '../../components/UI/inlineLoader';

const ContactUs = ({ headOfficeAddress, email, phoneNumbers, time }) => {
	const [timeOne, setTimeOne] = useState('');
	const [timeTwo, setTimeTwo] = useState('');
	const { register, handleSubmit, errors, reset } = useForm();

	const dispatch = useDispatch();

	const loadingState = useSelector((state) => state.loader.loading);

	useEffect(() => {
		if (time) {
			const firstTime = time?.opening_time?.split(':');
			const newFirstTime = firstTime[0] + ':' + firstTime[1];
			const secondTime = time?.closing_time.split(':');
			const newSecondTime = parseInt(secondTime[0]) - 12 + ':' + secondTime[1];

			setTimeOne(newFirstTime);
			setTimeTwo(newSecondTime);
		}
	}, [time]);

	const sendMessageHandler = async (data) => {
		dispatch(loader());
		const newData = {
			name: data.name,
			email: data.email,
			message: data.message,
			subject: data.subject,
		};
		
		if (data) {
			try {
				const { data } = await axiosInstance.post('contact', newData);
				dispatch(loader());
				NotificationManager.success(data.message, '', 3000);
			} catch (error) {
				dispatch(loader());
				NotificationManager.error(error.response.data.message, '', 3000);
				console.log(error);
			}
		}
		reset({});
	};

	const openingHours = [{ day: 'Mondays - Sundays', time: '8:00a.m - 7:00pm', id: 0 }];

	return (
		<>
			<section className='contact-us store-location'>
				<div className='container'>
					<div className='row'>
						<div className='col-md-5'>
							<h4>Leave us a message</h4>
							<form
								onSubmit={handleSubmit(sendMessageHandler)}
								className='signup-form contact-form'
							>
								<div className='textbox '>
									<input
										type='text'
										name='name'
										placeholder='Your name*'
										ref={register({ required: 'All fields are required.' })}
									/>
									{/* <div className={`border ${errors.name ? "border-error" : null}`}></div> */}
								</div>

								<div className='textbox'>
									<input
										type='email'
										name='email'
										placeholder='Your email address*'
										ref={register({ required: 'All fields are required.' })}
									/>
									<div className={`border ${errors.email ? 'border-error' : null}`}></div>
								</div>

								<div className='textbox'>
									<input
										type='text'
										name='subject'
										placeholder='Your phone number*'
										ref={register({ required: 'All fields are required.' })}
									/>
									<div className={`border ${errors.subject ? 'border-error' : null}`}></div>
								</div>

								<textarea
									className={errors.message ? 'textarea-error' : null}
									name='message'
									ref={register({ required: true })}
									placeholder='Your message*'
								/>
								{loadingState ? (
									<div className='text-center'>
										<InlineLoading />
									</div>
								) : (
									<button className='btn mt-5'>
										<span className='text'>Submit</span>
									</button>
								)}
								{(errors.message || errors.subject || errors.email || errors.name) && (
									<p className='error'>All fields are required.</p>
								)}
							</form>
						</div>
						<div className='col-md-1 d-md-block d-none offset-md-1'>
							<p className='line'></p>
						</div>
						<div className='col-md-4 mt-sm-0 mt-5 offset-md-1'>
							<h4>Opening hours</h4>
							<div className='d-flex align-items-center flex-wrap mb-4'>
								<p>Mondays - Sundays:-</p>
								<p className='ml-2'>{`${timeOne}a.m - ${timeTwo}pm`}</p>
							</div>
							<h6>Head office</h6>
							<p className='mb-4'>{headOfficeAddress}</p>
							<h6>Phone no</h6>
							<div>
								{phoneNumbers?.length > 0 &&
									phoneNumbers?.map((number, i) => {
										let numberDisplay;
										if (i === 0) {
											numberDisplay = (
												<p key={i} className='mb-2'>
													<a target='_blank' className='link-to-hr d-flex' href={`tel:${number}`}>
														{' '}
														<img
															src='/images/icon/phone.png'
															className='img-fluid phone-img'
															alt=''
														/>
														{number}{' '}
													</a>
												</p>
											);
										} else {
											numberDisplay = (
												<p key={i} className='mb-0'>
													<a
														target='_blank'
														className='link-to-hr d-flex'
														href={`https://api.whatsapp.com/send/?phone=+234${number}&text=Hi &app_absent=0`}
													>
														{' '}
														<img
															src='/images/icon/whatsapp.png'
															className='img-fluid phone-img'
															alt=''
														/>
														{number}{' '}
													</a>
												</p>
											);
										}
										return numberDisplay;
									})}
								{/* <p className="mb-0"> <a className="link-to-hr" href="tel:070054543663">0700 54543663, </a> </p> &nbsp;
                                <p className="mb-0"> <a className="link-to-hr" href="tel:08100393579">+2348100393579</a> </p> */}
							</div>

							<h6 className={'mt-4'}>Email</h6>
							<p>
								{' '}
								<a className='link-to-hr' href={`mailto:${email}`}>
									{email}
								</a>{' '}
							</p>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default ContactUs;
